/* eslint-disable no-underscore-dangle */
import { Nullable } from 'types';

// This class was created to catch the exact moment when the IUBenda cookie consent
// is given by the user and the analytics tracking is being initialized. Having this
// knowledge helps with triggering events such as the `user_status` event on the first
// run of the application.
export default class AnalyticsInitializationListener {
  private initializationListener: Nullable<() => void> = null;

  private _analyticsInitialized = false;

  set analyticsInitialized(value: boolean) {
    this._analyticsInitialized = value;
    if (this.initializationListener) {
      this.initializationListener();
    }
  }

  get analyticsInitialized(): boolean {
    return this._analyticsInitialized;
  }

  register(listener: () => void): void {
    this.initializationListener = listener;
  }
}
